import { ShieldCheck, UserCheck, Lock, Zap } from "lucide-react";
import Reveal from "./Reveal";

const REASONS = [
    {
        icon: ShieldCheck,
        title: "Registered & accountable",
        body: "A UK-registered limited company — Company No. 17432590 — that you can verify before you commit.",
    },
    {
        icon: UserCheck,
        title: "Dedicated support",
        body: "A consistent point of contact who learns your business, rather than a rotating cast of strangers.",
    },
    {
        icon: Lock,
        title: "Discreet & secure",
        body: "Your documents, data and diaries are handled in confidence, with care taken over every handoff.",
    },
    {
        icon: Zap,
        title: "Fast to start",
        body: "We work with your existing tools from day one — no heavy onboarding, no new software to learn.",
    },
];

const WhyUs = () => (
    <section id="why-us" data-testid="why-us-section" className="relative py-24 lg:py-32">
        <div className="mx-auto max-w-7xl px-6 lg:px-10">
            <Reveal>
                <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-amber-400">
                    03 — Why Admin Logic
                </p>
                <h2 className="mt-6 max-w-2xl font-display text-3xl font-bold tracking-tight sm:text-4xl lg:text-5xl">
                    Steady hands for the work behind the work.
                </h2>
            </Reveal>

            <div className="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
                {REASONS.map((r, i) => (
                    <Reveal key={r.title} delay={i * 0.08} className="h-full">
                        <div
                            data-testid={`why-us-card-${i + 1}`}
                            className="glass-card glass-card-hover flex h-full flex-col rounded-2xl p-8"
                        >
                            <div className="flex h-12 w-12 items-center justify-center rounded-xl border border-electric/30 bg-electric/10">
                                <r.icon className="h-5 w-5 text-electric-glow" />
                            </div>
                            <h3 className="mt-6 font-display text-lg font-bold tracking-tight text-white">
                                {r.title}
                            </h3>
                            <p className="mt-3 text-sm leading-relaxed text-slate-400">{r.body}</p>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);

export default WhyUs;
